'use strict';

define('native', [], function () {
	const module = 'JSBridge';
	const native = {};
	native.mock = !/Leedarson/i.test(navigator.userAgent);
	native.registered = false;
	native.listeners = {};

	function loadIframe() {
		const WVJBIframe = document.createElement('iframe');
		WVJBIframe.style.display = 'none';
		WVJBIframe.src = 'https://__bridge_loaded__';
		document.documentElement.appendChild(WVJBIframe);
		setTimeout(() => {
			document.documentElement.removeChild(WVJBIframe);
		}, 0);
		// 注意(临时方案): 为了解决 iOS WKWebView 的 history.go(-1) 没有 window.WebViewJavascriptBridge 属性问题, 因为原生拦截不到iframe的src
		setTimeout(() => {
			if (!window.WebViewJavascriptBridge) {
				loadIframe();
			}
		}, 50);
	}

	function setupWebViewJavascriptBridge(callback) {
		if (window.WebViewJavascriptBridge) {
			callback(window.WebViewJavascriptBridge); // bridge = WebViewJavascriptBridge
			return;
		}

		if (window.WVJBCallbacks) {
			window.WVJBCallbacks.push(callback);
			return;
		}

		window.WVJBCallbacks = [callback];

		loadIframe();
	}

	native.callHandler = function (request = {}, timeout = 0) {
		return new Promise((resolve, reject) => {
			const { key, message } = request || {};
			const { service = '', method = '' } = message || {};
			const SERVICE_METHOD = (service || method) && `/${service}.${method}`;
			const path = `${key}${SERVICE_METHOD}`;
			try {
				console.log(`${module} --> ${path}`, request);
				let timer = 0;
				if (timeout > 0) {
					timer = setTimeout(() => {
						const response = { code: 408, time: timeout, data: request, desc: 'Request Timeout' };
						console.log(`${module} <-- ${path}`, response);
						reject(response); // 超时返回, {code, data, desc}
					}, timeout);
				}
				setupWebViewJavascriptBridge((bridge) => {
					bridge.callHandler('JsCallNative', request, (response) => {
						clearTimeout(timer);
						console.log(`${module} <-- ${path}`, response);
						resolve(response); // 正常返回, {code, data, desc}
					});
				});
			} catch (error) {
				const response = { code: 400, data: error, desc: 'Bad Request' };
				console.log(`${module} <-- ${path}`, response);
				reject(response); // 异常返回, {code, data, desc}
			}
		});
	};

	native.send = function (request, timeout) {
		if (!this.mock) {
			return this.callHandler(request, timeout); // 正常返回, {code, data, desc}
		}
	};

	native.register = function () {
		if (this.mock) {
			return;
		}

		if (this.registered) {
			return;
		}

		this.registered = true;

		setupWebViewJavascriptBridge((bridge) => {
			bridge.registerHandler('NativeCallJs', async (requestData, responseCallback) => {
				const { key } = requestData || {};
				let code = 200;
				let responseData = [];
				let desc = '';
				try {
					const callbacks = this.getCallbacks(key);
					if (callbacks.length > 0) {
						console.log(`${module} <-- ${key}`, requestData);

						const promises = callbacks.map(callback => callback(requestData)); // JS监听回调处理
						responseData = await Promise.all(promises);
						responseData = responseData.filter(response => !!response);
					} else {
						code = 404;
						desc = 'Listener callback not found.';
						console.log(`${module} <-- ${key}`, requestData, desc);
					}
				} catch (e) {
					code = 400;
					desc = 'Listener callback execute error.';
					responseData = e;
					console.log(`${module} <-- ${key}`, requestData, responseData, desc);
				}
				if (Object.prototype.toString.call(responseCallback) === '[object Function]') {
					console.log(`${module} --> ${key}`, responseData, desc);
					responseCallback({ code, data: responseData, desc }); // JS返回监听回调处理结果给原生
				}
			});
		});
	};

	native.on = function (key, callback) {
		if (this.listeners[key] && this.listeners[key].length > 0) {
			this.listeners[key].push(callback);
		} else {
			this.send({
				key: 'JSBridge.addEventListener',
				event: key,
			});
			this.listeners[key] = [callback];
		}
	};

	native.off = function (key, callback) {
		if (Object.prototype.toString.call(callback) === '[object Function]') {
			const callbacks = this.getCallbacks(key);
			this.listeners[key] = callbacks.filter(cb => cb !== callback); // 移除某一个回调

			// 事件为空，移除事件
			if (!this.listeners[key] || this.listeners[key].length === 0) {
				this.send({
					key: 'JSBridge.removeEventListener',
					event: key,
				});
				delete this.listeners[key]; // 移除全部回调
			}
		} else {
			this.send({
				key: 'JSBridge.removeEventListener',
				event: key,
			});
			delete this.listeners[key]; // 移除全部回调
		}
	};

	native.trigger = function (key, data) {
		this.getCallbacks(key).forEach(callback => callback(data));
	};

	native.getCallbacks = function (key) {
		return this.listeners[key] || [];
	};

	// 业务支持功能
	native.openWebView = function (options) {
		return this.send({
			key: 'WebView.open',
			...options,
		});
	};

	native.closeWebView = function () {
		return this.send({
			key: 'WebView.close',
		});
	};

	native.didRender = function () {
		return this.send({
			key: 'WebView.didRender',
		});
	};

	native.updateStatusBarStyle = function () {
		return this.send({
			key: 'System.updateStatusBarStyle',
		});
	};

	native.previewMedia = function ({ current = 0, images }) {
		return this.send({
			key: 'Camera.previewMedia',
			supportSaveToAlbum: 0,
			urls: images,
			current,
			isHideNavbar: 0,
		});
	};

	native.copyToPasteboard = function (content = '') {
		if (!content || typeof content !== 'string') {
			return;
		}

		return this.send({
			key: 'System.copyToPasteboard',
			content,
		});
	};

	native.getPhoneInfo = function () {
		return this.send({
			key: 'System.getPhoneInfo',
		});
	};

	// 获取时间格式
	native.getTimeFormatType = function () {
		return this.send({
			key: 'System.getTimeFormatType',
		});
	};

	native.openBrowser = function (url) {
		return this.send({
			key: 'System.openBrowser',
			url,
		});
	};

	native.setTabBarVisible = function (visible) {
		return this.send({
			key: 'TabBar.visible',
			visible,
		});
	};

	native.register();

	window.native = native;

	return native;
});
